module.exports = __webpack_public_path__ + "static/media/img-link-bank-acct.601bf482.svg";